import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await authAPI.login({ email, password });
      onLogin(res.data.token, res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card card">
        <h1>keunson</h1>
        <p>시청자 후원 분석 서비스에 로그인하세요</p>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>이메일</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label>비밀번호</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호 입력"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 16, color: '#8B8B9E' }}>
          계정이 없으신가요? <Link to="/register">회원가입</Link>
        </p>

        <p style={{ textAlign: 'center', marginTop: 8, fontSize: '0.85rem', color: '#8B8B9E' }}>
          <Link to="/find-account">아이디 찾기</Link>
          <span style={{ color: '#4B4B5E', margin: '0 8px' }}>|</span>
          <Link to="/find-account?tab=password">비밀번호 찾기</Link>
        </p>

        <div style={{ textAlign: 'center', marginTop: 12, fontSize: '0.8rem' }}>
          <Link to="/privacy" style={{ color: '#6B6B7E' }}>개인정보처리방침</Link>
          <span style={{ color: '#4B4B5E', margin: '0 8px' }}>|</span>
          <Link to="/terms" style={{ color: '#6B6B7E' }}>서비스 약관</Link>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
